import { Link } from "react-router-dom";
import BaseLayout from "@/v2/components/BaseLayout";

export default function EditorialPage() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      name: "Korthet-redaktionen",
      url: "https://korthet.se/om-korthet/redaktionen",
      inLanguage: "sv-SE",
      about: {
        "@type": "Organization",
        name: "Korthet",
        url: "https://korthet.se/",
        email: "hello@korthet.se",
      },
    },
  ];

  return (
    <BaseLayout
      title="Korthet-redaktionen – så skapas sammanfattningarna | Korthet"
      description="Korthet-redaktionen ansvarar för det redaktionella systemet som automatiskt sammanfattar nyheter med AI. Så fungerar publiceringen, ansvaret och rättelserna."
      canonicalPath="/om-korthet/redaktionen"
      jsonLd={jsonLd}
    >
      <article className="k2-article-body">
        <h1 className="k2-article-title">Korthet-redaktionen</h1>

        <p className="k2-summary">
          Alla sammanfattningar på Korthet publiceras under bylinen{" "}
          <strong>Korthet-redaktionen</strong>. Det är inte en enskild journalist, utan
          det redaktionella system som Korthet ansvarar för: regler, kvalitetskrav och
          den AI-pipeline som skapar sammanfattningarna automatiskt.
        </p>

        <h2 className="k2-h2">Varför inte ett personnamn?</h2>
        <p>
          Korthet skriver inte egna nyhetsartiklar och vi hittar inte på AI-personer som
          författare. Texterna är automatiskt genererade sammanfattningar av publicerad
          nyhetsrapportering, och ansvaret ligger på Korthet som utgivare – inte på en
          fiktiv skribent.
        </p>

        <h2 className="k2-h2">Så skapas en sammanfattning</h2>
        <ul className="k2-bullets">
          <li>Vi hämtar nyheter från etablerade svenska nyhetskällors RSS/Atom-flöden.</li>
          <li>Texten analyseras av AI som skapar sammanfattning, viktiga punkter och artikelprofil.</li>
          <li>
            En publiceringsgrind kräver komplett resultat – sammanfattning, minst fyra
            punkter, huvudämne och faktakaraktär – annars publiceras artikeln inte.
          </li>
          <li>Varje artikel anger källa, publiceringstid och länk till originalet.</li>
        </ul>

        <h2 className="k2-h2">Redaktionellt ansvar</h2>
        <p>
          Korthet-redaktionen granskar systemets utfall löpande, rättar felklassificeringar
          via en intern granskningskö och tar bort artiklar som inte håller kvalitetskraven.
          Vi bedriver ingen egen nyhetsrapportering och länkar alltid vidare till originalkällan.
        </p>

        <h2 className="k2-h2">Rättelser och kontakt</h2>
        <p>
          Har du hittat ett fel i en sammanfattning, eller vill du att en artikel tas bort?
          Mejla <a href="mailto:hello@korthet.se">hello@korthet.se</a> med länken till
          sidan. Vi rättar eller avpublicerar så snart vi kan.
        </p>

        <p className="k2-disclaimer">
          Läs mer om tjänsten på <Link to="/om-korthet">Om Korthet</Link>.
        </p>
      </article>
    </BaseLayout>
  );
}
